export const SET_INITIAL_STATE = "set_initial_state";
export const INIT_BANKID = "init_bankid";
export const LOGIN_BANKID_SUCCESS = "login_bankid_success";
export const LOGIN_SUCCESS = "login_success";
export const LOGIN_BANKID_FAILED = "login_bankid_failed";
export const LOGIN_FAILED = "login_failed";
export const LOG_OUT = "logout";
export const GET_USER_DATA = "user_data";
export const UPDATE_DOCTORS_DATA = "update_doctors_data";
export const RESET_BANKID_OPERATION = "reset_bankid_operation";
export const UPDATE_USER_MEDICAL_INFO = "update_user_medical_info";
export const REMOVE_IMAGE = "remove_image";
export const CHANGE_IMAGE_STATUS = "change_image_status";

export const GET_DIAGNOSES = "get_diagnoses";
export const GET_CONSULTATION = "get_consultation";
export const AUTHENTICATION_FAILED = "auth_failed";
export const DOWNLOAD_FILE = "download";
export const SET_REMINDER = "set_reminder";
export const SET_REMINDER_STATUS = "set_reminder_status";
export const GET_EXCHANGE_CODE = "get_exchange_code";
